module.exports = __webpack_public_path__ + "static/logo_amica-26e1eb90bc868e90cbdcad0db3c91ca1.svg";